import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Boxes } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { useWorkingModel } from "@/hooks/useWorkingModel";
import { useDeliverable } from "@/hooks/useDeliverable";
import { PageHeader } from "@/components/PageParts";
import DeliverableState from "@/components/DeliverableState";
import { Button, Card, Empty } from "@/components/ui";

export default function Templates() {
  const { lang } = useAuth();
  const isAr = lang === "ar";
  const navigate = useNavigate();
  const [, setWm] = useWorkingModel();
  const { data, loading, error } = useDeliverable(() => api.wizardListTemplates(), []);
  const items = data?.items || [];

  async function use(tpl) {
    try {
      const r = await api.wizardInstantiateTemplate(tpl.id);
      setWm({ model: r.model, kind: tpl.kind || "villa", floors: 1, slab_system: "hordi_regular", title: isAr ? tpl.name_ar : tpl.name_en });
      toast.success(isAr ? "تم تحميل القالب" : "Template loaded");
      navigate("/editor");
    } catch (e) {
      toast.error(String(e.message || e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl px-4 py-6">
      <PageHeader eyebrow={isAr ? "القوالب" : "Templates"} title={isAr ? "قوالب جاهزة" : "Ready templates"} subtitle={isAr ? "ابدأ من قالب مصمم مسبقاً ثم عدّله." : "Start from a pre-built template, then edit it."} />
      <DeliverableState loading={loading} error={error} isAr={isAr}>
        {items.length === 0 ? (
          <Empty icon={Boxes} title={isAr ? "لا توجد قوالب" : "No templates"} />
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((t) => (
              <Card key={t.id} className="flex flex-col justify-between">
                <div>
                  <div className="font-black">{isAr ? t.name_ar : t.name_en}</div>
                  <div className="mt-1 text-xs text-muted-foreground">{t.kind} · {t.land_w}×{t.land_h} m</div>
                </div>
                <Button size="sm" className="mt-4" onClick={() => use(t)} data-testid={`use-template-${t.id}`}>{isAr ? "استخدم القالب" : "Use template"}</Button>
              </Card>
            ))}
          </div>
        )}
      </DeliverableState>
    </div>
  );
}
